import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { ProductStatus } from '@ibk/shared-types';
import ProductCard from '../ProductCard';
export default function BeneficiosCard({ id, status, onClick, 'data-testid': dataTestId, metaData, isLoading, ...props }) {
    const { t } = useTranslation();
    const beneficiaryCount = typeof metaData?.beneficiaryCount === 'number' ? metaData.beneficiaryCount.toString() : '';
    const statusElement = status === ProductStatus.CONTRACTED ? (_jsxs(_Fragment, { children: [t('products.status.beneficiaries-label'), _jsxs("strong", { "data-testid": `product-card-contracted-data-${id}`, children: ["\u00A0", beneficiaryCount] })] })) : null;
    return (_jsx(ProductCard, { ...props, id: id, status: status, onClick: onClick, "data-testid": dataTestId ?? `beneficios-card-${id}`, statusElement: statusElement, isLoading: isLoading }));
}
